var urlBase =  
[
    {
        //urlBase: "http://localhost:2020"
        urlBase: "http://147.182.160.95:2020"
    }
];
export default urlBase;